import * as types from '../types/mediaTypes';

const initialState = {
  detail: null,
  loading: false,
  error: null,
};

export default function mediaReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_MEDIA_DETAIL_REQUEST:
      return { ...state, loading: true, error: null, detail: null };
    case types.FETCH_MEDIA_DETAIL_SUCCESS:
      return { ...state, loading: false, detail: action.payload };
    case types.FETCH_MEDIA_DETAIL_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}
